import Icon from 'components/base/Icon';
import React from 'react';
import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';

const WhiteBorder = styled.div`
  position: relative;
  padding: 0.875rem;
  border-radius: 50%;
  border: 1px solid ${getColor('botticelli')};
  background: #fff;
  z-index: 0;
  cursor: ${({ isclickable }) => (isclickable ? 'pointer' : 'auto')};
  ${({ isGrayedOut }) => (isGrayedOut ? `filter: grayscale(100%)` : '')};
`;

const GhostAvatar = ({ idx }) => {
  return (
    <WhiteBorder
      style={{ marginLeft: idx > 0 ? `-1.25rem` : 0 }}
      isclickable={true}
      isGrayedOut={false}
    >
      <Icon name='GhostAvatar' size='small' color='osloGray' />
    </WhiteBorder>
  );
};

export default GhostAvatar;
